/**
 * O mesmo desenho do admin e do cardápio: traço de 1,8, pontas arredondadas e
 * `currentColor`. Só os ícones que esta página usa entram aqui — copiar o
 * arquivo inteiro traria trinta símbolos de tela de operação que nunca aparecem
 * numa página de divulgação.
 *
 * `currentColor` é o que permite o mesmo ícone servir sobre o roxo do bloco
 * escuro e dentro do quadradinho claro do cartão, sem uma variante para cada.
 */
function IconBase({ size = 20, children, ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {children}
    </svg>
  );
}

export function IconCheck(props) {
  return (
    <IconBase {...props}>
      <path d="M20 6 9 17l-5-5" />
    </IconBase>
  );
}

export function IconCheckCircle(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="m8.5 12 2.5 2.5 4.5-5" />
    </IconBase>
  );
}

export function IconArrowRight(props) {
  return (
    <IconBase {...props}>
      <path d="M5 12h14M13 6l6 6-6 6" />
    </IconBase>
  );
}

export function IconMoped(props) {
  return (
    <IconBase {...props}>
      <circle cx="6" cy="17.5" r="2.5" />
      <circle cx="18" cy="17.5" r="2.5" />
      <path d="M8.5 17.5h7M15.5 17.5 13 8h-2" />
      <path d="M13 8h4l2 6" />
    </IconBase>
  );
}

export function IconStore(props) {
  return (
    <IconBase {...props}>
      <path d="M4 10v9a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-9" />
      <path d="M3 6.5 4.5 4h15L21 6.5a3 3 0 0 1-6 0 3 3 0 0 1-6 0 3 3 0 0 1-6 0Z" />
      <path d="M9.5 20v-5h5v5" />
    </IconBase>
  );
}

export function IconWhatsapp({ size = 20, ...props }) {
  // Único preenchido do conjunto: a marca do WhatsApp é reconhecida pela
  // silhueta cheia, e em traço ela vira "um balão de fala qualquer".
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      <path d="M12.04 2C6.6 2 2.2 6.4 2.2 11.84c0 1.74.46 3.44 1.32 4.94L2 22.5l5.86-1.5a9.9 9.9 0 0 0 4.18.93h.01c5.43 0 9.84-4.4 9.84-9.84 0-2.63-1.02-5.1-2.88-6.96A9.78 9.78 0 0 0 12.04 2Zm0 1.8c2.14 0 4.15.84 5.67 2.35a7.98 7.98 0 0 1 2.35 5.68c0 4.45-3.62 8.06-8.07 8.06a8.1 8.1 0 0 1-3.7-.9l-.27-.15-2.72.7.73-2.65-.18-.28a8 8 0 0 1-1.24-4.29c0-4.45 3.62-8.06 8.06-8.06Zm4.66 10.16c-.24-.13-1.46-.72-1.68-.8-.23-.09-.4-.13-.56.12-.16.25-.63.8-.77.96-.15.16-.28.18-.52.06-.24-.12-1.04-.38-1.97-1.22-.73-.65-1.22-1.45-1.36-1.7-.15-.24-.02-.37.1-.5.11-.1.24-.28.36-.42.12-.14.16-.24.24-.4a.45.45 0 0 0-.02-.43c-.06-.13-.55-1.35-.76-1.84-.2-.48-.4-.42-.55-.43h-.48c-.16 0-.43.06-.65.3-.22.25-.86.85-.86 2.06s.88 2.39 1 2.56c.13.16 1.74 2.66 4.22 3.73.59.25 1.05.4 1.4.52.6.18 1.14.16 1.56.1.48-.07 1.47-.6 1.68-1.19.2-.58.2-1.08.15-1.18-.06-.11-.22-.17-.46-.3Z" />
    </svg>
  );
}

export function IconQrCode(props) {
  return (
    <IconBase {...props}>
      <rect x="3.5" y="3.5" width="6" height="6" rx="1" />
      <rect x="14.5" y="3.5" width="6" height="6" rx="1" />
      <rect x="3.5" y="14.5" width="6" height="6" rx="1" />
      <path d="M14.5 14.5h3v3M20.5 20.5h-3v-3" />
    </IconBase>
  );
}

export function IconClock(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5.2l3.2 2" />
    </IconBase>
  );
}

export function IconPalette(props) {
  return (
    <IconBase {...props}>
      <path d="M12 3a9 9 0 0 0 0 18c1.1 0 1.8-.8 1.8-1.7 0-.5-.2-.9-.5-1.2-.3-.3-.5-.7-.5-1.1 0-.9.8-1.7 1.7-1.7H16a5 5 0 0 0 5-5c0-3.9-4-7.3-9-7.3Z" />
      <circle cx="7.8" cy="11.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="10.5" cy="7.6" r="1" fill="currentColor" stroke="none" />
      <circle cx="15.2" cy="8.4" r="1" fill="currentColor" stroke="none" />
    </IconBase>
  );
}

export function IconMapPin(props) {
  return (
    <IconBase {...props}>
      <path d="M12 21c4-4.2 6-7.4 6-10a6 6 0 1 0-12 0c0 2.6 2 5.8 6 10Z" />
      <circle cx="12" cy="11" r="2.3" />
    </IconBase>
  );
}

export function IconSmartphone(props) {
  return (
    <IconBase {...props}>
      <rect x="6" y="2.5" width="12" height="19" rx="2.5" />
      <path d="M10.5 18.5h3" />
    </IconBase>
  );
}

export function IconShield(props) {
  return (
    <IconBase {...props}>
      <path d="M12 3 5 6v5.5c0 4 2.9 7.6 7 9.5 4.1-1.9 7-5.5 7-9.5V6l-7-3Z" />
      <path d="m9 12 2.2 2.2L15.5 10" />
    </IconBase>
  );
}

export function IconDollarSign(props) {
  return (
    <IconBase {...props}>
      <path d="M12 2.5v19M16.5 6.8c-.8-1-2.3-1.6-4.2-1.6-2.4 0-4 1.2-4 3s1.4 2.6 4 3.2c2.8.6 4.4 1.4 4.4 3.4s-1.8 3.2-4.4 3.2c-2.1 0-3.7-.7-4.6-1.8" />
    </IconBase>
  );
}

export function IconLayers(props) {
  return (
    <IconBase {...props}>
      <path d="m12 3 8.5 4.5L12 12 3.5 7.5 12 3Z" />
      <path d="m3.5 12 8.5 4.5 8.5-4.5M3.5 16.5 12 21l8.5-4.5" />
    </IconBase>
  );
}

export function IconUtensils(props) {
  return (
    <IconBase {...props}>
      <path d="M6 3v8a2.5 2.5 0 0 0 5 0V3M8.5 11v10" />
      <path d="M17.5 3c-1.4 1.2-2 3-2 5.5 0 1.6.7 2.5 2 2.8V21" />
    </IconBase>
  );
}

export function IconColumns(props) {
  return (
    <IconBase {...props}>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M9 4v16M15 4v16" />
    </IconBase>
  );
}

export function IconList(props) {
  return (
    <IconBase {...props}>
      <path d="M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01" />
    </IconBase>
  );
}

export function IconSettings(props) {
  return (
    <IconBase {...props}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9c.63.29 1.3.46 2 .51H21a2 2 0 0 1 0 4h-.09c-.7.05-1.37.22-2 .51z" />
    </IconBase>
  );
}

export function IconChevronDown(props) {
  return (
    <IconBase {...props}>
      <polyline points="6 9 12 15 18 9" />
    </IconBase>
  );
}
